angular.module('tasks.meeting-attendance')
    .controller('TaskMeetingAttendanceLogsController', function ($http, toastr, $scope, $rootScope, $uibModalInstance, data, TaskMeetingAttendance) {
        this.$onInit = () => {
            TaskMeetingAttendance.logs({id: data.id}).$promise.then(result => {
                this.items = result
            });
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled');
    })
